import { useQuery } from "@tanstack/react-query";
import { IProgramGridFilter, ProgramModelForDropdown } from "./types";
import { program } from "./query";
import { PostModel } from "common/models/BaseModel";

export function GetPrograms(model: PostModel<IProgramGridFilter> | undefined) {
  return useQuery(program.list(model));
}

export function GetProgram(Id: string | number) {
  return useQuery({
    ...program.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetProgramValues() {
  return useQuery(program.getProgramValues());
}

export function GetProgramView(id: string | number, isOpen: boolean) {
  return useQuery({
    ...program.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}

export function GetProgramByInstituteDepartment(
  model: ProgramModelForDropdown
) {
  return useQuery({
    ...program.getProgramByInstituteDepartment(model),
    enabled:
      model !== undefined && Boolean(model.instituteID) && Boolean(model.departmentID),
  });
}
